export default __webpack_public_path__ + "static/media/I_Ilha.7f967512.svg";